export default "/shCOLLAB.09381d7caa3e0087afa835730cfdc348.svg";